export default __webpack_public_path__ + "media/titles/title_5_locale_de-40658ed5.png";